import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
const Header = styled("div")(({ theme }) => ({ display: "flex", gap: "20px" }));
const Linked = styled(Link)(({ theme }) => ({ height: "50px" }));

const Maincontant = styled("div")(({ theme }) => ({
  "& h6": {
    ...theme.authTitle,
    marginBottom: "10px",
  },
  "& p": {
    ...theme.authsubTit,
    marginBottom: "40px",
    fontSize: "16px",
    lineHeight: "24px",
    color: "rgba(11, 11, 11, 0.6)",
    "& span": {
      color: "#0B0B0B !important",
      paddingLeft: "12px",
      fontWeight: 600,
    },
  },
}));

const PaymentMethodBtn = styled("div")(({ theme }) => ({
  "& img": { width: "30px", height: "30px" },
  margin: "15px 0",
  gap: "10px",
  display: "flex",
  padding: "10px",
  background: "#F2F2F2",
  borderRadius: "12px",
  fontFamily: theme.typography.fontFamily,
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "14px",
  lineHeight: "14px",
  color: "#0B0B0B",
  textTransform: "capitalize",
  cursor: "pointer",
  alignItems: "center",
  "& span": {
    display: "block",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    color: "rgba(11, 11, 11, 0.75)",
  },
}));

export { Header, Linked, Maincontant, PaymentMethodBtn };
